/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
import { useWindowSize } from '@brands/hooks';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import { Button } from '@mui/material';
import React, { FC, useMemo } from 'react';
import Modal, { Styles } from 'react-modal';

import closeICon from './closeIconSVG.svg';
import styles from './styles.module.scss';

interface NoServiceAvailableModalProps {
  isOpen: boolean;
  hideModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const mobileCustomStylesDashboard: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...(customStylesDashboard?.overlay || {}),
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    overflowY: 'scroll' as const,
    overflowX: 'hidden' as const,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    ...(customStylesDashboard?.content || {}),
    width: '88%',
    height: 'auto',
    padding: '64px 16px 24px 16px',
    margin: '0 24px 0 24px',
    borderRadius: '8px',
    position: 'fixed',
    top: '50%',
    left: '44%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
  },
};

const customStylesDashboardDesktop: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...customStylesDashboard.overlay,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  content: {
    position: 'relative',
    padding: '55px 32px 32px',
    borderRadius: '4px',
    minWidth: '444px',
    width: '444px',
    maxHeight: '90vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
};
const NoServiceAvailableModal: FC<NoServiceAvailableModalProps> = ({ isOpen, hideModal }) => {
  const screenSize = useWindowSize();
  const isMobile = useMemo(() => screenSize.width < 768, [screenSize.width]);

  const roleNavigate = useRoleNavigate();
  const backToDashboard = (): void => {
    roleNavigate('/dashboard');
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => hideModal(false)}
      style={isMobile ? mobileCustomStylesDashboard : customStylesDashboardDesktop}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className={styles.closeICon}>
        <img
          src={closeICon}
          onClick={() => {
            hideModal(false);
          }}
        />
      </div>

      <div className={styles.noServiceContainer}>
        <div className={styles.noServiceContainerHeader}>
          <span className={styles.noServicelHeader}>Selected service not available in your location</span>
          <span className={styles.noServiceContent}>
            It appears that your location has changed since you selected a service, and the chosen service is not
            available in your current area. Please verify that your location is accurate or return to select a different
            service.
          </span>
        </div>

        <div className={styles.insuranceModalButtons}>
          <Button
            type="submit"
            variant="contained"
            className={styles.save}
            color="primary"
            data-testid="unsaved-change-modal-save-changes"
            onClick={backToDashboard}
          >
            Return to Dashboard
          </Button>
        </div>
      </div>
    </Modal>
  );
};

Modal.setAppElement('#root');

export default NoServiceAvailableModal;
